// initial state
const state = {
  isLoading: false
}

// getters
const getters = {}

// actions (async and xhrs)
const actions = {}

// mutations - Synchronous operations
const mutations = {
  SET_LOADING (state, boolean) {
    state.isLoading = boolean
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
